import AOS from 'aos';
import SmoothScroll from "smoothscroll-for-websites";

new SmoothScroll({ stepSize: 60 });

AOS.init({
    once: true,
    offset: 100,
    duration: 700,
    delay: 200
});

const header = document.querySelector('.page-header');
const loginLinksBlock = document.querySelector('.page-header__login-links');
const loginBtn = document.querySelector('.page-header__login');

// scrolled menu
window.addEventListener('scroll', () => {
    if(window.pageYOffset > 0) {
        header.classList.add('h-w');
    } else if (window.pageYOffset <= 0) {
        header.classList.remove('h-w');
    }
});

// Login btn hover effect on mouse event
if(loginLinksBlock) {
    loginLinksBlock.addEventListener('mouseover', () => {
        loginBtn.classList.add('btn-h');
    });

    loginLinksBlock.addEventListener('mouseout', () => {
        loginBtn.classList.remove('btn-h');
    });
}

// Language Switcher
if(document.querySelector('.widget-language')) {
    document.querySelector('.widget-language').addEventListener('click', function H() {
        document.querySelector('.language-switcher').classList.toggle('show');
    });

    window.addEventListener('click',(e) => {
        if(e.target !== document.querySelector('.js-wpml-ls-item-toggle')) {
            document.querySelector('.language-switcher').classList.remove('show');
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const links = document.querySelectorAll('a[href*="#"]');

    links.forEach(function (link) {
        link.addEventListener('click', function (event) {
            const targetHref = link.getAttribute('href');
            const [urlPath, hash] = targetHref.split('#');

            // Перевірити чи посилання веде на ту ж саму сторінку
            const samePage = (link.pathname === location.pathname) && (link.hostname === location.hostname);

            if (samePage && hash) {
                const targetId = hash;
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    event.preventDefault();
                    window.scrollTo({
                        top: targetElement.offsetTop - 74,
                        behavior: 'smooth'
                    });
                }
            }

            document.querySelector('.burger-wrapper').querySelector('.burger').classList.toggle('open');
            document.querySelector('.mob-overlay').classList.toggle('open');
            document.querySelector('.page-header__inner-wrapper').classList.toggle('open');
            document.querySelector('.page-body').classList.toggle('open');
        });
    });
});
